import React, { Component } from "react";
import html2canvas from 'html2canvas';
import Header from "./Header"

class MemeGenerator extends Component {
    constructor() {
        super()
        this.state = {
            topText: "",
            bottomText: "",
            randomImg: "http://i.imgflip.com/1bij.jpg",
            allMemeImgs: []
        }
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    componentDidMount() {
        fetch("https://api.imgflip.com/get_memes")
            .then(response => response.json())
            .then(response => {
                const { memes } = response.data
                this.setState({ allMemeImgs: memes })
            })
    }

    handleChange(event) {
        const { name, value } = event.target
        this.setState({ [name]: value })
    }

    handleSubmit(event) {
        event.preventDefault()
        const randNum = Math.floor(Math.random() * this.state.allMemeImgs.length)
        const randMemeImg = this.state.allMemeImgs[randNum].url
        this.setState({ randomImg: randMemeImg })
    }

    saveImg(event) {
        event.preventDefault()
        window.scrollTo({ top: 0 });
        html2canvas(document.querySelector("#capture"), {
            useCORS: true
        }).then(canvas => {
            // document.body.appendChild(canvas)
            var tab = window.open('about:blank', '_blank');
            tab.document.body.appendChild(canvas);
            tab.document.close(); 
        });
    }

    render() {
        return (
            <div className="container">
                <form className="meme-form">
                <Header />

                    <input
                        type="text"
                        name="topText"
                        placeholder="Top Text"
                        value={this.state.topText}
                        onChange={this.handleChange}
                    />
                    <input
                        type="text"
                        name="bottomText"
                        placeholder="Bottom Text"
                        value={this.state.bottomText}
                        onChange={this.handleChange}
                    />

                    <button onClick={this.handleSubmit}>Randomise!</button>
                    <button onClick={this.saveImg}>Save</button>
                </form>
                <div></div>
                <div className="meme" id="capture" >
                    <img src={this.state.randomImg} alt="IMG" />
                    <h2 className="top">{this.state.topText}</h2>
                    <h2 className="bottom">{this.state.bottomText}</h2>
                </div>
            </div>
        )
    }
}

export default MemeGenerator